<div class="table-row">
	@let
	r = getDataRow();
	@if (showDate()) {
		<div>{{row().date | date: 'HH:mm'}}</div>
	}
	<div class="font-decimaBold">
		{{row().data.ai.analysis.mealType | titlecase}}
	</div>

	<div class="ml-auto">
		@let
		rating = row().data.ai.analysis.items[0].processingLevel;
		<app-ui-food-rating [rating]="rating"></app-ui-food-rating>
	</div>
</div>